
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1815_90676)","fill":"#1D1D1D","stroke":"#fff"}},[_c('path',{attrs:{"d":"M19.769 6.595v.233c-.562 2.987-2.574 3.967-5.1 3.967h-1.31a.608.608 0 00-.609.513l-.655 4.153-.187 1.167c-.047.186.14.373.328.373h2.292c.281 0 .515-.187.562-.466v-.094l.42-2.706.048-.14a.555.555 0 01.561-.467h.328c2.199 0 3.93-.887 4.445-3.5.233-1.073.093-2.007-.468-2.613-.188-.14-.375-.327-.655-.42z"}}),_c('path',{attrs:{"d":"M19.769 6.594c.187-1.073 0-1.82-.609-2.52-.608-.746-1.778-1.073-3.322-1.073H11.44a.647.647 0 00-.608.513L9.007 15.087c-.047.234.14.42.375.42h2.713l.702-4.293v.14a.602.602 0 01.608-.513h1.31c2.527 0 4.492-1.027 5.1-3.967-.046-.14-.046-.28-.046-.28z"}})]),_c('rect',{attrs:{"x":".5","y":".501","width":"29","height":"19","rx":"1.5","stroke":"#1D1D1D"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1815_90676"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(9 3.001)","d":"M0 0h12v14H0z"}})])])])
          )
        }
      }
    